import { ShellNav } from './ShellNav';

export function DesktopSidebar() {
  return (
    <aside aria-label="Navigation principale">
      <ShellNav variant="rail" />
    </aside>
  );
}
